import LoginModel from "@/models/login.model";
import Vue from "vue";
import store from '@/store';
import UsuarioModel from "@/models/usuario.model";
import RedirectUtil from "@/util/redirect";
import {MapActionsModule} from "@/store/modules/auth/map-actions.auth";
import {StatusLoginEnum} from "@/enums/status-login.enum";
import {MapActionsSnackbarModule} from "@/store/modules/snackbar/map-actions.snackbar";

class AutenticacaoService {

    STATUS_OK: number = 200;
    redirect = RedirectUtil;

    async login(body: LoginModel, vue: Vue): Promise<any> {
        await Vue.prototype.$axios.post('login', body)
            .then(async (response: any) => {
                if (response.status === this.STATUS_OK) {
                    localStorage.jwt = response.data.token;
                    const usuario: UsuarioModel = await this.me();
                    await store.dispatch(MapActionsModule.SALVAR_USUARIO_LOGADO, usuario);
                    await store.dispatch(MapActionsModule.ALTERAR_STATUS_LOGIN, StatusLoginEnum.LOGADO);
                    this.redirect.to(vue, "Inicio", null);
                    await store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Login efetuado com sucesso!');
                }
                if (response.status === 203) {
                    await store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Credenciais inválidas!');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

    async me(): Promise<any> {
        return await Vue.prototype.$axios.get('me')
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const usuarioLogado: UsuarioModel = response.data;
                    return usuarioLogado;
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

}

export default new AutenticacaoService();
